interface Props {
  [key: string]: any
}

export default function VideoPlayerIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props

  return (
    <svg fill="none" height="46" viewBox="0 0 73 46" width="73" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : 'fill-current'}
        clipRule="evenodd"
        d="M0 36.2714C0 38.6763 0.957657 40.9828 2.6623 42.6833C4.36694 44.3839 6.67893 45.3392 9.08965 45.3392H43.1758C45.3805 45.3395 47.5101 44.5404 49.1681 43.0907C50.8261 41.6411 51.8994 39.6397 52.1882 37.4593L66.3226 43.7252C67.0145 44.0327 67.7724 44.1628 68.5275 44.1038C69.2826 44.0448 70.0109 43.7984 70.6463 43.3871C71.2817 42.9758 71.8039 42.4126 72.1656 41.7487C72.5273 41.0848 72.7169 40.3413 72.7172 39.5857V5.75355C72.7165 4.99854 72.5269 4.25565 72.1655 3.5923C71.804 2.92895 71.2823 2.36614 70.6475 1.95496C70.0128 1.54377 69.2852 1.29723 68.5307 1.2377C67.7762 1.17817 67.0188 1.30754 66.3272 1.61408L52.1882 7.87996C51.8994 5.69954 50.8261 3.69815 49.1681 2.2485C47.5101 0.798847 45.3805 -0.000255585 43.1758 0H9.08965C6.67893 0 4.36694 0.955364 2.6623 2.65591C0.957657 4.35646 0 6.66291 0 9.06785V36.2714Z"
        fillRule="evenodd"
      />
    </svg>
  )
}
